import { useEffect, useRef, useState } from "react";

import clsx from "clsx";

import { TertiaryButton } from "@shared/buttons";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const NameInput = ({ value, onChange }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [name, setName] = useState(value);
  const [isEditingName, setIsEditingName] = useState(false);

  useEffect(() => setName(value), [value]);

  return (
    <>
      {isEditingName ? (
        <div className="flex items-center gap-1">
          <input
            ref={inputRef}
            className="text-2xl border-b border-gray-2 py-0.5"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={() => {
              setIsEditingName(false);
              onChange(name);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setIsEditingName(false);
                onChange(name);
              }
            }}
          />
          <TertiaryButton
            className="font-bold rounded-lg h-7 py-0 px-2 mt-2"
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            onClick={() => {
              setIsEditingName(false);
              setName(value);
            }}
          >
            Cancel
          </TertiaryButton>
          <TertiaryButton
            className="font-bold rounded-lg h-7 py-0 px-2 mt-2"
            onClick={() => {
              setIsEditingName(false);
              onChange(name);
            }}
          >
            Save
          </TertiaryButton>
        </div>
      ) : (
        <div>
          <div className="flex items-center gap-2">
            <div className="text-2xl font-bold py-0.5 border-b border-[white]">
              {value}
            </div>
            <TertiaryButton
              className={clsx(
                "flex items-center justify-center w-6 h-6 p-0 mt-1 rounded-md bg-cosmic-3",
                "hover:bg-cosmic-2",
              )}
              onClick={() => {
                setIsEditingName(true);
                setTimeout(() => {
                  inputRef.current?.focus();
                });
              }}
            >
              <i className="fa-regular fa-pen" />
            </TertiaryButton>
          </div>
        </div>
      )}
    </>
  );
};
